/**
 * Drop any cached front-end assets and reload the latest build.
 *
 * After a deploy the browser can keep serving an old `index.html` (which
 * points at stale hashed CSS/JS), so the page looks broken until a hard
 * refresh. This clears the Cache Storage API + any service worker, then
 * reloads — the server now serves `index.html` with `Cache-Control:
 * no-cache` (see frontend/nginx.conf), so the reload picks up the newest
 * asset hashes.
 *
 * Auth storage (localStorage/sessionStorage) is deliberately left intact
 * so the user stays signed in.
 */
export async function clearAppCache() {
  // 1. Cache Storage API entries (a service worker / PWA shell, if present).
  try {
    if (typeof caches !== "undefined" && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch { /* best-effort */ }

  // 2. Unregister any service workers. There are none today, but this keeps
  //    a future (or stray) SW from continuing to serve old assets.
  try {
    if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch { /* best-effort */ }

  // 3. Reload. `index.html` is served no-cache, so the browser revalidates
  //    and fetches the latest hashed asset references.
  window.location.reload();
}
